export default {
    Left: require('./images/arrows_left.png'),
    Right: require('./images/arrows_right.png'),
    Trashcan: require('./images/garbage_lukket.png'),
    Canvas: require('./images/Lisehoeg.dk-canvas2.jpg'),
    User: require('./images/Lisehoeg.jpg'),
    Usertext: "Jeg har beskæftiget mig med keramik i ca. 20 år og laver unika kvindefigurer og kjoler. Mine skåle er lavet i en form, men håndformet så ingen skåle er ens. Jeg bruger en teknik på min blå stentøjsskåle, hvor de er fuldglaseretindvendig, men glasuren er fjernet på den udvendige side. Jeg kan godt lide det lidt rå udtryk sammen med den tynde skål."
}